module.exports = __webpack_public_path__ + "static/media/poste_7.9168bbd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_7.jpg
// module id = 264
// module chunks = 0